import type { GenerationSlug, HealthResponse, MembersResponse, SortMode, VideoKind, VideosResponse } from '../types.ts';

const API_BASE = (import.meta.env.VITE_API_BASE as string) ?? 'https://stelsearch.stellive.workers.dev/api/v1';

export interface VideosQuery {
  q?: string;
  group?: GenerationSlug;
  members?: string[];
  kind?: VideoKind;
  sort?: SortMode;
  cursor?: string;
  limit?: number;
}

export async function fetchVideos(p: VideosQuery, signal?: AbortSignal): Promise<VideosResponse> {
  const url = new URL(`${API_BASE}/videos`);
  if (p.q) url.searchParams.set('q', p.q);
  if (p.group) url.searchParams.set('group', p.group);
  if (p.members && p.members.length > 0) url.searchParams.set('members', p.members.join(','));
  if (p.kind) url.searchParams.set('kind', p.kind);
  if (p.sort) url.searchParams.set('sort', p.sort);
  if (p.cursor) url.searchParams.set('cursor', p.cursor);
  if (p.limit) url.searchParams.set('limit', String(p.limit));

  const res = await fetch(url.toString(), { signal });
  if (!res.ok) throw new Error(`videos fetch failed: ${res.status}`);
  return res.json();
}

export async function fetchMembers(): Promise<MembersResponse> {
  const res = await fetch(`${API_BASE}/members`);
  if (!res.ok) throw new Error(`members fetch failed: ${res.status}`);
  return res.json();
}

export async function fetchHealth(): Promise<HealthResponse> {
  const res = await fetch(`${API_BASE}/health`);
  // /health returns 503 when stale but still has a valid body.
  if (res.status !== 200 && res.status !== 503) {
    throw new Error(`health fetch failed: ${res.status}`);
  }
  return res.json();
}

export function youtubeWatchUrl(videoId: string): string {
  return `https://www.youtube.com/watch?v=${videoId}`;
}

export function youtubeThumbnailUrl(videoId: string): string {
  return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
}
